import { api } from './api'

/**
 * The learner's own profile photo (V5-b): `me_uploadPhoto` (multipart,
 * field `file`) and `me_removePhoto`. Both answer the whole profile
 * (`MeProfileDto`, with `photoUrl` and `features`), the shape `fetchProfile`
 * returns. Whether uploads are switched on is `features.photosEnabled` on
 * that profile (V5-w-flags) — nothing here asks the server separately.
 */

export async function uploadPhoto(blob) {
  const body = new FormData()
  body.append('file', blob, 'photo.jpg')
  const { data } = await api.post('/me/upload-photo', body)
  return data
}

export async function removePhoto() {
  const { data } = await api.post('/me/remove-photo')
  return data
}
